export const LOCATION_FILTER_OPTIONS = [
  {
    value: "",
    label: "Select Care Location"
  },
  {
    value: "DENVER_CAREHUB_01",
    label: "Denver Care Hub @ 2101 Larimer St, Denver"
  },
  {
    value: "CHARLESTON_NV_89104",
    label: "Las Vegas Care Hub @ 8 E Charleston Blvd"
  }
];
